import { DashboardItemPillVariant } from './types';

const lightGray = 'text-neutral-600 bg-neutral-100';
const gray = 'text-neutral-800 bg-neutral-100';
const cyan = 'text-task-aqua-800 bg-task-aqua-100';
const purple = 'text-task-purple-800 bg-task-purple-100';
const indigo = 'text-task-indigo-800 bg-task-indigo-100';
const lime = 'text-task-lime-800 bg-task-lime-100';
const yellow = 'text-task-yellow-600 bg-task-yellow-100';
const orange = 'text-task-orange-secondary-600 bg-task-orange-secondary-100';
const warning = 'text-warning-700 bg-warning-100';

export const variants: Record<DashboardItemPillVariant, string> = {
  ['no_schedule']: '',
  default: gray,
  dependent: gray,
  external: cyan,
  ['extra_attributes_update']: purple,
  file: gray,
  form: lime,
  internal: gray,
  manual: gray,
  ['standard_task']: indigo,
  ['required']: yellow,
  ['estimated_and_final_values']: lightGray,
  ['fieldUpdate']: lightGray,
  ['doubleEntryRequired']: lightGray,
  ['material_order']: cyan,
  ['material_measurement']: purple,
  ['hotSeat']: orange,
  warning,
};
